import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import utils from './static/js/utils'
import { JSEncrypt } from 'jsencrypt'
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';
NutUI.install(Vue)
import ElementUI from 'element-ui';
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css';
import http from '@/service/http'
import base from '@/service/base'
import './static/style/nomal.css'// 初始化样式
import VueWechatTitle from 'vue-wechat-title' // 动态标题
Vue.use(VueWechatTitle)
const plugins = [utils]; // 插件列表
plugins.map(plg => Vue.use(plg)); // 引入插件
Vue.config.productionTip = false
Object.assign(Vue.prototype, { $http: http });
Object.assign(Vue.prototype, { $base: base });
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
// Vue.prototype.$base = base
// /* RSA加密 */
// Vue.prototype.$setRSA = (password, publicKey) =>{
//     let encrypt = new JSEncrypt()
//     encrypt.setPublicKey(publicKey)
//     return encrypt.encrypt(password)
// }
// Vue.prototype.$getRSA = (rsa ,priKey)=>{
//     let decrypt = new JSEncrypt()
//     decrypt.setPrivateKey(priKey)
//     return decrypt.decrypt(rsa)
// }
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
